import React from "react";
import { Check, X } from "lucide-react";

/**
 * Comparison table: The Local Loot vs a traditional Facebook ad.
 * Used on the public /sponsors page to sell the value proposition.
 */
const ROWS = [
  { feature: "Engagement", loot: "100% Physical Presence", fb: "0.5% Click-through" },
  { feature: "Viral Potential", loot: "High (user-generated videos)", fb: "Low (static image)" },
  { feature: "Local Impact", loot: "Immediate foot traffic", fb: "Delayed awareness" },
  { feature: '"Cool" Factor', loot: "Off the charts", fb: "Average" },
  { feature: "Community Goodwill", loot: "Strong — you're funding free cash & chests", fb: "Neutral" },
  { feature: "Measurable ROI", loot: "QR scans, selfies, named winners", fb: "Impressions ≠ customers" },
];

export default function SponsorValueTable() {
  return (
    <div className="loot-card p-0 overflow-hidden" data-testid="sponsor-value-table">
      <div className="grid grid-cols-[1.1fr_1.4fr_1.4fr] border-b" style={{ borderColor: "rgba(245,242,232,0.12)" }}>
        <div className="px-4 md:px-6 py-4 font-mono text-[10px] md:text-xs uppercase tracking-widest" style={{ color: "#F5F2E8", background: "rgba(245,242,232,0.04)" }}>
          Feature
        </div>
        <div
          className="px-4 md:px-6 py-4 font-display uppercase text-sm md:text-base"
          style={{
            color: "#0F0F0F",
            background: "#D7A62A",
            letterSpacing: "0.03em",
          }}
          data-testid="value-col-loot"
        >
          The Local Loot
        </div>
        <div
          className="px-4 md:px-6 py-4 font-display uppercase text-sm md:text-base"
          style={{
            color: "#F5F2E8",
            background: "rgba(245,242,232,0.08)",
            letterSpacing: "0.03em",
          }}
          data-testid="value-col-fb"
        >
          Traditional Facebook Ad
        </div>
      </div>
      {ROWS.map((r, i) => (
        <div
          key={r.feature}
          className="grid grid-cols-[1.1fr_1.4fr_1.4fr] border-b"
          style={{
            borderColor: "rgba(245,242,232,0.08)",
            background: i % 2 === 0 ? "transparent" : "rgba(245,242,232,0.02)",
          }}
          data-testid={`value-row-${i}`}
        >
          <div className="px-4 md:px-6 py-4 font-display uppercase text-sm md:text-base" style={{ color: "#F5F2E8" }}>
            {r.feature}
          </div>
          <div className="px-4 md:px-6 py-4 text-sm md:text-base flex items-start gap-2" style={{ color: "#F5F2E8" }}>
            <Check size={16} className="shrink-0 mt-0.5" style={{ color: "#76B82A" }} />
            <span>{r.loot}</span>
          </div>
          <div className="px-4 md:px-6 py-4 text-sm md:text-base flex items-start gap-2" style={{ color: "rgba(245,242,232,0.55)" }}>
            <X size={16} className="shrink-0 mt-0.5" style={{ color: "#E53935" }} />
            <span>{r.fb}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
